export enum UnitStatusEnum {
  /** @deprecated The Upcoming status is deprecated. All Upcoming entries have been migrated to Available status. */
  Upcoming = 'Upcoming',
  Available = 'Available',
  Reserved = 'Reserved',
  Sold = 'Sold',
  Rented = 'Rented'
}

// Mapper les valeurs numériques vers les valeurs string de l'enum
export const getUnitStatusString = (status: any): string => {
  if (typeof status === 'string') {
    return status;
  }
  
  // Map des valeurs numériques vers les strings correspondants
  const statusMap: { [key: number]: string } = {
    0: 'Upcoming',
    1: 'Available',
    2: 'Reserved',
    3: 'Sold',
    4: 'Rented'
  };
  
  return statusMap[status] || 'Available';
};

// Vérifier si une unité est désactivée (Réservée, Vendue ou Louée)
export const isUnitDisabled = (status: any): boolean => {
  const statusString = getUnitStatusString(status);
  return statusString === 'Reserved' || statusString === 'Sold' || statusString === 'Rented';
};
